/**
 * O número da fila do Feedback no menu — spec 0108 (FR-015, DD-24).
 *
 * O setor Corporativo não tinha fonte de contadores; esta é a primeira. Conta
 * o que espera a equipe (Recebido), a cada minuto e só com a aba do navegador
 * visível. A casca registra a fonte só para quem vê a fila: para os outros,
 * a rota responderia 403 a cada minuto.
 */
import { registrarFonteDeContadores } from '../../config/contadores';
import { lerContadorDaFila } from './api';

const INTERVALO_MS = 60_000;

let recebidos = 0;
let ligados = 0;
let relogio: number | undefined;
const avisos = new Set<() => void>();
let registrado = false;

async function ler(): Promise<void> {
  if (document.visibilityState !== 'visible') return;
  try {
    const n = await lerContadorDaFila();
    if (n !== recebidos) {
      recebidos = n;
      avisos.forEach((a) => a());
    }
  } catch {
    // Sem número é melhor que número errado: fica o da última leitura.
  }
}

/** A fila mudou (resposta, abertura): lê de novo agora, sem esperar o minuto. */
export function releContadorDoFeedback(): void {
  if (registrado) void ler();
}

export function registrarFonteDoFeedback(): void {
  if (registrado) return;
  registrado = true;
  registrarFonteDeContadores('corporativo', {
    ler: () => ({ feedback: recebidos }),
    assinar: (aviso) => { avisos.add(aviso); return () => { avisos.delete(aviso); }; },
    ligar: () => {
      ligados += 1;
      if (ligados === 1) {
        void ler();
        relogio = window.setInterval(() => { void ler(); }, INTERVALO_MS);
      }
      return () => {
        ligados -= 1;
        if (ligados === 0 && relogio !== undefined) { window.clearInterval(relogio); relogio = undefined; }
      };
    },
  });
}
